import { TableCell, TableRow, TableRowProps } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

export const StyledTableRow = styled(TableRow)((props: TableRowProps & { isParent?: boolean }) =>`
  background-color: ${props.isParent ? COLORS.LightBackground1 : 'transparent'};
  position: sticky;
  top: 0;
`);

export const HeadingCell = styled(TableCell)`
  font-weight: 600;
  white-space: nowrap;
`;